import React, { useRef, useContext, useState, useEffect } from "react";
import { View, TouchableOpacity, I18nManager, Text } from "react-native";
import { ReactComponent as Language } from "../assets/images/language.svg";
import GText from "../Elements/GText";
import { StringsContext } from "../DataFactory/useStrings";
import { useDetectOutsideClick } from "../DataFactory/useDetectOutsideClick";
import useLocalStorage from "../DataFactory/useLocalStorage";
import styled from "styled-components";
import { ApiService } from "../services";
import { SettingsContext } from "../DataFactory/useSettings";

const Div = styled.div`
  &.languageDiv {
    background: #fff;
    box-shadow: 0 0 13px #c1bebe8f;
    border-top: 3px solid ${({ theme }) => theme.body};
    padding: 10px 0;
  }
`;

const ChangeLanguage = () => {
  const [initialLoading, setInitialLoading] = useState(true);
  const [strings, isRTL, availableLaunguages, language, setLanguage] =
    useContext(StringsContext);
  const refRBSheet = useRef();
  const { settings, setSettings } = useContext(SettingsContext);
  const [lang, setLang] = useLocalStorage("language");
  const [isLOpen, setIsLOpen] = useDetectOutsideClick(refRBSheet, false);

  const getLanguage = (language) => {
    return (
      availableLaunguages.find((t) => t.languageCode == language) ||
      availableLaunguages[0]
    );
  };

  useEffect(() => {
    // console.log(language);
    if (settings?.user?.id && !language) {
      setLang(language);
      setLanguage(language);
      if (["ar"].includes(language)) {
        I18nManager.allowRTL(true);
        I18nManager.forceRTL(true);
      } else {
        I18nManager.allowRTL(false);
        I18nManager.forceRTL(false);
      }
    }
  }, [settings]);

  useEffect(() => {
    if (settings?.user?.id && initialLoading == false) {
      let sendData = {
        locale: language,
      };
      ApiService({ method: "PUT", route: "c/me", body: sendData }).then(
        (response) => {
          console.log(response.data);
          if (response.data.status_code === 1) {
            settings.user = response.data.data;
            setSettings({ ...settings });
          }
        }
      );
    }
    setInitialLoading(false);
  }, [language]);

  return (
    <React.Fragment>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TouchableOpacity
          style={{ padding: 5 }}
          onPress={() => setIsLOpen(true)}
        >
          <div
            style={{
              display: "inline-flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Language
              style={{
                width: "18px",
                height: "18px",
                paddingRight: "2px",
                transform: I18nManager.getConstants().isRTL
                  ? "scale(-1, 1)"
                  : "scale(1, 1)",
              }}
            />
            &nbsp;
            <Text
              style={{
                marginBottom: 0,
                lineHeight: "26px",
                // textTransform: "uppercase",
              }}
            >
              {getLanguage(language)?.title}
            </Text>
          </div>
        </TouchableOpacity>
      </View>
      {isLOpen == true && (
        <div
          ref={refRBSheet}
          height={50 + 50 * availableLaunguages.length}
          style={{
            position: "absolute",
            right: "0",
            top: "58px",
            minWidth: "150px",
            textAlign: "left",
          }}
        >
          <Div className="languageDiv">
            {availableLaunguages.map((c, i) => (
              <TouchableOpacity
                style={{ paddingVertical: 10, paddingHorizontal: 15 }}
                key={i}
                onPress={() => {
                  setLang(c.languageCode);
                  setLanguage(c.languageCode);
                  if (["ar"].includes(c.languageCode)) {
                    I18nManager.allowRTL(true);
                    I18nManager.forceRTL(true);
                  } else {
                    I18nManager.allowRTL(false);
                    I18nManager.forceRTL(false);
                  }
                  // RNRestart.Restart();
                  setIsLOpen(false);
                }}
              >
                <GText text={c.title} />
              </TouchableOpacity>
            ))}
          </Div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ChangeLanguage;
